import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var LogOut04 = function LogOut04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m18 8 4 4m0 0-4 4m4-4H9m6-7.796C13.7252 3.4383 12.2452 3 10.6667 3 5.8802 3 2 7.0294 2 12s3.8802 9 8.6667 9c1.5785 0 3.0585-.4383 4.3333-1.204"
    })
  }));
};
export default LogOut04;